<template>
  <!-- 大咖个人资料 -->
  <div>
    <el-form
      :model="authorInfo"
      status-icon
      :rules="rules"
      ref="authorInfo"
      class="demo-ruleForm"
    >
      <!-- label-width="100px" -->
      <div class="author-info-content">
        <div class="aic-float" v-if="isDetail">
          <div v-on:click="edit()" class="aic-float-right">
            <span class="aic-float-sp">更改认证资料</span>
          </div>
        </div>

        <div class="aic-item">
          <div
            class="aic-inp"
            :class="{
              'is-error': submited && !authorInfo.headpic1,
              'avatar-uploader-has': authorInfo.headpic1
            }"
          >
            <el-form-item label="头像:" prop="headpic1">
              <div>
                <div class="avatar-uploader-swap" @click="avatarUploader">
                  <el-upload
                    class="avatar-uploader"
                    :class="{
                      'avatar-uploader-enable':
                        !editEnable && authorInfo.headpic1,
                      'is-edit-enable': editEnable
                    }"
                    :action="uploadUrl"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload"
                    :on-progress="onAvatarProgress"
                    :disabled="editEnable"
                    :accept="'image/*'"
                  >
                    <img
                      v-if="authorInfo.headpic1"
                      :src="authorInfo.headpic1"
                      class="avatar"
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div class="avatar-uploader-hover">
                      <span>修改头像</span>
                    </div>
                  </el-upload>
                  <el-progress
                    v-if="avatarPercentage !== 0"
                    :percentage="avatarPercentage"
                    status="success"
                  ></el-progress>
                </div>
                <div>
                  <span class="uploader-sp">建议上传彩色工作证件照</span>
                </div>
              </div>
            </el-form-item>
          </div>
        </div>
        <div class="aic-item">
          <div class="aic-inp">
            <el-form-item label="认证的身份:" prop="atype">
              <el-radio-group
                v-bind:disabled="editEnable"
                @change="AuthorTypeChange"
                v-model="authorInfo.atype"
              >
                <el-radio :label="0">投资顾问</el-radio>
                <el-radio :label="2">特约嘉宾</el-radio>
                <el-radio :label="1">分析师</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </div>

        <div class="aic-item aic-item-el-form">
          <div class="aic-inp">
            <el-form-item label="真实姓名:" prop="realname">
              <el-input
                v-model="authorInfo.realname"
                v-bind:disabled="editEnable"
                placeholder="请输入真实姓名"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="aic-item">
          <div class="aic-inp">
            <el-form-item label="性别:" prop="sex">
              <el-radio-group
                v-bind:disabled="editEnable"
                @change="AuthorTypeChange"
                v-model="authorInfo.sex"
              >
                <el-radio :label="1">男</el-radio>
                <el-radio :label="0">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </div>
        <div v-if="specialGuests" class="aic-item aic-item-el-form">
          <div class="aic-inp">
            <el-form-item label="昵称:" prop="nickname">
              <el-input
                v-model="authorInfo.nickname"
                v-bind:disabled="editEnable"
                placeholder="请输入昵称"
              ></el-input>
            </el-form-item>
          </div>
        </div>

        <div v-if="specialGuests" class="aic-item">
          <div class="aic-inp">
            <div class="inp-text">
              <el-form-item label="公司名称:" prop="corp">
                <el-input
                  v-model="authorInfo.corp"
                  v-bind:disabled="editEnable"
                  placeholder="请输公司名称"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </div>

        <div v-if="!specialGuests" class="aic-item">
          <div class="aic-inp">
            <div class="inp-text">
              <el-form-item label="机构名称:" prop="corp">
                <el-select
                  v-model="authorInfo.corp"
                  v-bind:disabled="editEnable"
                  filterable
                  placeholder="请选择机构名称"
                  @change="CorpChange"
                >
                  <el-option-group
                    v-for="group in getInstitutions"
                    :key="group.label"
                    :label="group.label"
                  >
                    <el-option
                      v-for="item in group.options"
                      :key="item.label"
                      :label="item.label"
                      :value="item.label"
                    >
                    </el-option>
                  </el-option-group>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </div>

        <div v-if="!specialGuests" class="aic-item">
          <div class="aic-inp">
            <el-form-item label="所在营业部:" prop="dept">
              <el-input
                v-model="authorInfo.dept"
                v-bind:disabled="editEnable"
                placeholder="请输所在营业部"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div v-if="!specialGuests" class="aic-item">
          <div class="aic-inp">
            <el-form-item label="资格编号:" prop="certid">
              <el-input
                v-model="authorInfo.certid"
                v-bind:disabled="editEnable"
                placeholder="请输资格编号"
              ></el-input>
            </el-form-item>
          </div>
        </div>

        <div class="aic-item">
          <div class="aic-inp" :class="{ 'is-error': isAddrError }">
            <el-form-item label="所在地区:" prop="area">
              <div>
                <VueAddress
                  :province="authorInfo.province"
                  :city="authorInfo.city"
                  :district="authorInfo.district"
                  :disabled="editEnable"
                  @change="handlerChange"
                ></VueAddress>
              </div>
            </el-form-item>
          </div>
        </div>

        <div v-if="!specialGuests" class="aic-item">
          <div class="aic-inp">
            <div class="inp-text">
              <el-form-item label="从业年限:" prop="workyears">
                <el-select
                  v-model="authorInfo.workyears"
                  v-bind:disabled="editEnable"
                  placeholder="请选择"
                  @change="WorkyearsChange"
                >
                  <el-option
                    v-for="item in workyearsPptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </div>

        <div v-if="specialGuests" class="aic-item">
          <div class="aic-inp">
            <div class="inp-text">
              <el-form-item label="QQ号码:" prop="qq">
                <el-input
                  v-bind:disabled="editEnable"
                  v-model="authorInfo.qq"
                  placeholder="请输入QQ号码"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
        <div v-if="specialGuests" class="aic-item">
          <div class="aic-inp">
            <div class="inp-text">
              <el-form-item label="推荐码:" prop="invitecode">
                <el-input
                  v-bind:disabled="editEnable"
                  v-model="authorInfo.invitecode"
                  placeholder="请输入推荐码"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
        <div v-if="specialGuests" class="aic-item">
          <div class="aic-inp">
            <div class="inp-text">
              <el-form-item label="推荐人姓名:" prop="recomname">
                <el-input
                  v-bind:disabled="editEnable"
                  v-model="authorInfo.recomname"
                  placeholder="请输入推荐人姓名"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
        <div v-if="specialGuests" class="aic-item">
          <div class="aic-inp">
            <div class="inp-text">
              <el-form-item label="推荐人手机号:" prop="recommobilephone">
                <el-input
                  v-bind:disabled="editEnable"
                  v-model="authorInfo.recommobilephone"
                  placeholder="请输入推荐人手机号"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
        <!-- 非注册 -->
        <div v-if="isDetail || isEdit" class="aic-item aic-item-udf">
          <div class="sp-muilt">
            <div class="aic-sp">
              <span class="aic-sp-must">*</span>
              <span class="aic-sp">擅长投资品种: </span>
            </div>
            <span class="aic-sp">（请选择1-3项）</span>
          </div>
          <div class="aic-inp">
            <div class="aic-muilt-bg">
              <div class="aic-muilt-swap-3">
                <el-checkbox-group
                  v-bind:disabled="editEnable"
                  v-model="authorInfo.tagexpert"
                >
                  <el-checkbox label="A股"></el-checkbox>
                  <el-checkbox label="港股"></el-checkbox>
                  <el-checkbox label="美股"></el-checkbox>
                  <el-checkbox label="基金"></el-checkbox>
                  <el-checkbox label="期货"></el-checkbox>
                  <el-checkbox label="其他"></el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </div>
        </div>

        <div v-if="isDetail || isEdit" class="aic-item aic-item-udf">
          <div class="sp-muilt">
            <div class="aic-sp">
              <span class="aic-sp-must">*</span>
              <span class="aic-sp">能力标签: </span>
            </div>
            <span class="aic-sp">（请选择1-5项）</span>
          </div>
          <div class="aic-inp">
            <div class="aic-muilt-bg">
              <div class="aic-muilt-swap-4">
                <el-checkbox-group
                  v-bind:disabled="editEnable"
                  v-model="authorInfo.tagskill"
                >
                  <el-checkbox label="技术面分析"></el-checkbox>
                  <el-checkbox label="波段操作"></el-checkbox>
                  <el-checkbox label="基本面分析"></el-checkbox>
                  <el-checkbox label="个股分析"></el-checkbox>
                  <el-checkbox label="大盘分析"></el-checkbox>
                  <el-checkbox label="长线操作"></el-checkbox>
                  <el-checkbox label="行业分析"></el-checkbox>
                  <el-checkbox label="基金理财"></el-checkbox>
                  <el-checkbox label="资产重组"></el-checkbox>
                  <el-checkbox label="打新"></el-checkbox>
                  <el-checkbox label="信托"></el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </div>
        </div>

        <div v-if="isDetail || isEdit" class="aic-item">
          <div class="aic-inp">
            <div class="inp-textarea">
              <el-form-item label="简介:" prop="remark">
                <el-input
                  type="textarea"
                  :rows="8"
                  :disabled="editEnable"
                  placeholder="请输入个人简介"
                  v-model="authorInfo.remark"
                >
                </el-input>
              </el-form-item>
            </div>
          </div>
        </div>
        <!-- 下一步 -->
        <div v-if="!isDetail" class="aic-item">
          <!-- <span class="aic-sp"></span> -->
          <div class="aic-inp">
            <div class="aic-inp-btn">
              <el-form-item label=" ">
                <el-button @click.native="submit()" type="primary">{{
                  postContent.btnText
                }}</el-button>
                <!-- 取消 -->
                <el-button
                  :class="{ hide: isRegisting || isDetail }"
                  @click.native="cancel()"
                  type="info"
                  >取消</el-button
                >
              </el-form-item>
            </div>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import Institutions from '@/assets/js/Institutions.json'
import VueAddress from '@/components/VueAddress'
import Urls from '@/assets/js/Urls'
export default {
  components: { VueAddress },
  props: {
    post: {
      type: Object
    }
  },
  data() {
    // 校验公司名称
    var validateCorp = (rule, value, callback) => {
      if (!value || value === '') {
        if (this.specialGuests && !value) {
          callback(new Error('请输入公司名称'))
        } else {
          callback(new Error('请选择机构名称'))
        }
      } else {
        callback()
      }
    }
    return {
      postContent: {
        // 状态：0-注册 1-详情 2-详情编辑
        state: 0,
        btnText: '下一步'
      },
      uploadUrl: `${Urls.DOMAIN_STATIC}/Upload/Image`,
      btnShow: this.showEditBtn,
      avatarPercentage: 0,
      authorInfo: {
        headpic1: '',
        atype: 0,
        realname: '',
        nickname: '',
        sex: 1,
        area: '',
        workyears: '',
        certid: '',
        dept: '',
        title: '',
        tagexpert: [],
        remark: '',
        certtype: '0',
        tagskill: [],
        province: '',
        city: '',
        district: '',
        corp: '',
        qq: '',
        invitecode: '',
        recomname: '',
        recommobilephone: '',
        recommobileguid: ''
      },
      rules: {
        realname: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' },
          { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
        ],
        nickname: [
          { required: true, message: '请输入昵称', trigger: 'blur' },
          { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
        ],
        headpic1: {
          required: true,
          message: '请上传头像照片',
          trigger: 'change'
        },
        atype: { required: true },
        sex: { required: true },
        workyears: {
          required: true,
          message: '请选择从业年限',
          trigger: 'change'
        },
        certid: { required: true, message: '请输入资格编号', trigger: 'blur' },
        corp: { validator: validateCorp, required: true, trigger: 'blur' },
        dept: { message: '请输入所在营业部', trigger: 'blur' },
        title: '',
        tagexpert: [],
        remark: { required: true, trigger: 'blur' },
        certtype: { required: true, trigger: 'blur' },
        tagskill: [],
        area: { required: true, message: '请选择所在地区', trigger: 'change' },
        province: { required: true, trigger: 'blur' },
        city: { required: true, trigger: 'blur' },
        district: { required: true, trigger: 'blur' },
        qq: {},
        invitecode: {},
        recomname: {},
        recommobilephone: {},
        recommobileguid: {}
      },
      workyearsPptions: [
        {
          value: '1-3年',
          label: '1-3年'
        },
        {
          value: '3-5年',
          label: '3-5年'
        },
        {
          value: '5-10年',
          label: '5-10年'
        },
        {
          value: '10年以上',
          label: '10年以上'
        }
      ],
      submited: false
    }
  },
  computed: {
    // 特约嘉宾
    specialGuests() {
      return this.authorInfo.atype === 2
    },
    isRegisting() {
      return this.postContent.state === 0
    },
    isDetail() {
      return this.postContent.state === 1
    },
    isEdit() {
      return this.postContent.state === 2
    },
    editEnable() {
      return this.isDetail
    },
    // 机构列表
    getInstitutions() {
      return Institutions
    },
    isAddrError() {
      return this.submited && !this.authorInfo.area
    }
  },
  methods: {
    CorpChange() {
      this.$refs.authorInfo.clearValidate('corp')
    },
    WorkyearsChange() {
      this.$refs.authorInfo.clearValidate('workyears')
    },
    edit() {
      this.postContent.state = 2
    },
    cancel() {
      this.postContent.state = 1
      this.$emit('cancel')
    },
    // 提交
    submit() {
      // 状态改为已点击提交
      this.submited = true
      var validateResult = this.validateForm()
      if (validateResult) {
        // 推荐人手机号
        if (!/^1\d{10}$/.test(this.authorInfo.recommobilephone)) {
          this.authorInfo.recommobilephone = ''
        }
        this.$emit('submit', this.authorInfo)
      }
    },
    // 校验表单
    validateForm() {
      var validateResult = true
      // 校验字段
      var validateField = ['headpic1', 'realname', 'corp', 'area']
      if (this.specialGuests) {
        validateField.push('nickname')
        validateField.push('qq')
        validateField.push('invitecode')
        validateField.push('recomname')
        validateField.push('recommobilephone')
      } else {
        this.authorInfo.nickname = this.authorInfo.realname
        validateField.push('certid')
        validateField.push('workyears')
        validateField.push('dept')
      }
      this.$refs.authorInfo.validateField(validateField, errorMsg => {
        if (errorMsg) {
          validateResult = false
        }
      })
      // 单独校验头像
      if (!this.authorInfo.headpic1) {
        validateResult = false
      } else {
        this.authorInfo.headpic1 = this.authorInfo.headpic1.replace(
          'blob:http',
          'http'
        )
      }

      return validateResult
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    AuthorTypeChange(val) {
      this.authorInfo.atype = val
      // this.$refs.authorInfo.validateField('recomname')
    },
    isLastItem(i) {
      return i === this.stepContent.length - 1
    },
    handlerChange: function (val) {
      if (val.province || val.city || val.district) {
        this.authorInfo.province = val.province
        this.authorInfo.city = val.city
        this.authorInfo.district = val.district
        // this.authorInfo.area
        var areaVal = `${this.authorInfo.province},${this.authorInfo.city},${this.authorInfo.district}`
        this.$set(this.authorInfo, 'area', areaVal)
        this.$refs.authorInfo.validateField('area')
      }
    },
    handleAvatarSuccess(res, file) {
      this.authorInfo.headpic1 = res.detail
      this.$refs.authorInfo.validateField('headpic1')
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2

      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!')
      // }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    onAvatarProgress(event, file, fileList) {
      this.avatarPercentage = event.percent
      if (this.avatarPercentage === 100) {
        setTimeout(() => {
          this.avatarPercentage = 0
        }, 500)
      }
    },
    avatarUploader() {
      if (this.editEnable) {
        this.$alert('点击【更改认证资料】后可编辑头像', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
      }
    }
  },
  created() {
    Object.assign(this.postContent, this.post)
    if (
      this.$store.getters['auth/isLogin'] &&
      this.$store.state.user.authorInfo
    ) {
      // 赋值
      this.authorInfo = JSON.parse(
        JSON.stringify(this.$store.state.user.authorInfo)
      )
      // 拆解地区
      if (this.authorInfo.area) {
        var sp = this.authorInfo.area.split(',')
        this.authorInfo.province = sp.length > 0 ? sp[0] : ''
        this.authorInfo.city = sp.length > 1 ? sp[1] : ''
        this.authorInfo.district = sp.length > 2 ? sp[2] : ''
      }
      // json list
      if (typeof this.authorInfo.tagexpert === 'string') {
        this.authorInfo.tagexpert = this.authorInfo.tagexpert
          ? JSON.parse(this.authorInfo.tagexpert)
          : []
      }
      if (typeof this.authorInfo.tagskill === 'string') {
        this.authorInfo.tagskill = this.authorInfo.tagskill
          ? JSON.parse(this.authorInfo.tagskill)
          : []
      }
    }
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>

<style>
.hide {
  display: none;
}
.space-20 {
  width: 20px;
}
/* 头像 */
.aic-item .aic-inp .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.aic-item .aic-inp .uploader-sp {
  margin: 40px;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 40px;
  letter-spacing: 0px;
  color: #858585;
}
.aic-item .avatar-uploader-has .avatar-uploader .el-upload {
  border-color: #ffffff;
  /* border-radius: 100%; */
}
.aic-item .aic-inp .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.aic-item .aic-inp .avatar-uploader.is-edit-enable .el-upload:hover {
  border-color: #d9d9d9;
  cursor: not-allowed;
}
.aic-item .aic-inp .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.aic-item .aic-inp .avatar {
  width: 178px;
  height: 178px;
  display: block;
}

/* 背景 */
.aic-inp .el-textarea__inner,
.aic-inp .el-input__inner {
  background-color: #ffffff;
}

/* 单选框 */
.aic-inp .el-radio__input.is-checked + .el-radio__label {
  color: #046bcc;
}

.aic-inp .is-disabled .el-radio__input.is-checked + .el-radio__label {
  color: #c0c4cc;
}
.aic-inp .el-radio__input.is-checked .el-radio__inner {
  border-color: #046bcc;
  background: #046bcc;
}
.aic-item .aic-inp .is-disabled .is-checked .el-radio__inner {
  border-color: #858585;
  background: #858585;
}

/* 复选框 */
.aic-inp .aic-muilt-bg .el-checkbox-group {
  flex-wrap: wrap;
  padding: 25px;
}
.aic-inp .aic-muilt-bg .el-checkbox-group .el-checkbox {
  width: 90px;
}

.aic-inp
  .aic-muilt-bg
  .el-checkbox-group
  .el-checkbox.is-disable
  .el-checkbox__input.is-checked
  + .el-checkbox__label {
  color: #858585;
}
.aic-inp
  .aic-muilt-bg
  .el-checkbox-group
  .el-checkbox__input.is-disabled.is-checked
  .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #858585;
  border-color: #858585;
}
/* 禁用 */
.aic-inp .inp-text .el-input.is-disabled .el-input__inner,
.aic-inp .el-input.is-disabled .el-input__inner,
.aic-inp .el-checkbox__input.is-disabled .el-checkbox__inner,
.aic-inp .el-textarea.is-disabled .el-textarea__inner {
  background-color: #fff;
}

/* btn */
.aic-item .aic-inp .aic-inp-btn .el-button {
  width: 180px;
}
.aic-item .is-error .el-input__inner {
  border-color: #e64c2e;
}
.aic-item .aic-inp .aic-inp-btn .el-button + .el-button {
  margin-left: 40px;
}
/* form */
.aic-item .aic-inp .el-form-item .el-form-item__content .el-input {
  width: 370px;
}
.aic-item .aic-inp .el-form-item .el-form-item__content .el-textarea {
  width: 570px;
}
/* address */
.aic-item .aic-inp .address .el-form-item__content .el-input {
  width: auto;
}
/* error */
.aic-item .is-error .avatar-uploader .el-upload {
  border-color: #e64c2e;
}
.author-info-content .el-form-item__label {
  min-width: 120px !important;
}
.el-radio__input.is-disabled.is-checked .el-radio__inner::after {
  background-color: #ffffff;
}
/* textarea */
.inp-textarea .el-form-item--feedback {
  align-items: flex-start !important;
}
.aic-item .el-progress {
  width: 100%;
}
.aic-item .el-progress-bar {
  padding-right: 0;
  margin-right: 0;
}
</style>
